/**
 * Build a display title for an event without duplicating the year when it is
 * already present in the event name (e.g. "Effie Awards Sri Lanka 2026").
 */
export function formatEventDisplayTitle(event) {
  const eventName = String(event?.name || '').trim();
  const eventYearRaw = Number(event?.eventYear);
  const eventYear = Number.isFinite(eventYearRaw)
    ? String(eventYearRaw)
    : (event?.startDate ? String(new Date(event.startDate).getFullYear()) : '');

  if (!eventName) return eventYear || 'Event';
  if (!eventYear) return eventName;
  if (new RegExp(`\\b${eventYear}\\b`).test(eventName)) return eventName;
  return `${eventName} ${eventYear}`;
}
